import Link from 'next/link';
import { renderInitialCircle } from 'utils/renderInitialCircle';

type CreatorProps = {
  username?: string;
  imageUrl?: string;
  createdAt?: string;
};

export const Creator = ({ username, imageUrl, createdAt }: CreatorProps) => {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-2">
        <div className="relative size-10 rounded-full overflow-hidden flex items-center justify-center">
            {!username ? (
              renderInitialCircle('?')
            ) : imageUrl ? (
              <img
                  src={imageUrl}
                  alt={`${username}'s profile`}
                  className="rounded-full size-10"
              />
            ) : (
              renderInitialCircle(username)
            )}
        </div>
        <div>
          <p className="text-xs text-stone-600">Created by</p>
          {username ? (
            <Link href={`/u/${username}`} className="text-gray-300 text-sm hover:text-brand">
              {username}
            </Link>
          ) : (
            <p className="text-stone-300 text-sm">Anonymous</p>
          )}
        </div>
      </div>
      { createdAt && (
        <div className="px-2 items-center gap-2">
            <p className="text-xs text-stone-600">Created on</p>
            <p className="text-stone-400 text-sm">
            {new Date(createdAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            })}
            </p>
        </div>
      )}
    </div>
  );
};